"use strict";

import jQuery from 'jquery';

/**
 *	Konstruktor
 */
gc.gis.module.GCNavigationHistory = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	var self = this;

	this.map           = options.map || gc.gis.iface.map;
	this.label         = options.label || 'Navigation';
	this.history_index = 0;
	this.history       = [];    // eigentlich sollte hier der aktuelle Viewport rein, aber irgendeine Aktion feuert im Initailisierungsprozess gc.gis.map.GCMapEvent.VIEWPORT_CHANGEEND, obwohl der Nutzer noch keine Aktion getätigt hat => Dopplung vermeinde
	this._active       = false;

	this._render();
	this.__updateButtons();

	this.map.on( gc.gis.map.GCMapEvent.VIEWPORT_CHANGEEND, this, function(evt)
	{
		if(!self._active && self.__hasViewportChanged(evt.viewport))
		{
			if(self.history_index < self.history.length - 1)
			{
				self.history.splice(self.history_index + 1, self.history.length - self.history_index);
			}
			self.addViewport(evt.viewport);
			self.history_index = self.history.length - 1;
			self.__updateButtons();
		}
		else if(self._active === true)
		{
			setTimeout(function() {
				self._active = false;
				self.__updateButtons();
			}, 500);
		}
	});

	// Initialer Button-Status
	self.__updateButtons();

	//gc.gis.iface.ui.mapToolbarRotate.addItem(this.element);

	gc.gis.iface.ui.attach(this.element, {
		target: gc.gis.iface.ui.main,
		order: -1
	});
};
gc.gis.module.GCNavigationHistory.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype._render = function()
{
	var self = this;

	this.btn_prev = jQuery('<button>', {
		'class': 'gc-map-control-button gc-action-previous',
		title: 'Vorheriger Kartenausschnitt',
		html: '<span class="gc-icon glyphicon glyphicon-chevron-left"></span><span>Zurück</span>',
		click: function( evt ) {
			evt.preventDefault();
			if( !self._active )
			{
				try
				{
					self.goPrev();
				}
				catch(err)
				{
					gc.gis.iface.log.error(this, err);
				}
			}
			jQuery(this).blur();
		}
	});
	this.btn_next = jQuery('<button>', {
		'class': 'gc-map-control-button gc-action-next',
		title: 'Nächster Kartenausschnitt',
		html: '<span class="gc-icon glyphicon glyphicon-chevron-right"></span><span>Vor</span>',
		click: function( evt ) {
			evt.preventDefault();
			if( !self._active )
			{
				try
				{
					self.goNext();
				}
				catch(err)
				{
					gc.gis.iface.log.error(this, err);
				}
			}
			jQuery(this).blur();
		}
	});

	this.element = jQuery('<div>', {
		'class': 'gc-viewport-history gc-map-control'
	});
	this.element.append( this.btn_prev ).append( this.btn_next );

	gc.gis.iface.ui.tooltip(this.btn_prev);
	gc.gis.iface.ui.tooltip(this.btn_next);

	return this.element;
};

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype.__hasViewportChanged = function(vp)
{
	if (this.history.length > 0)
	{
		var last = this.history[this.history.length - 1];
		return !(vp.geometry === last.geometry
			&& vp.rotation === last.rotation
			&& vp.projection === last.projection);
	}

	return true;
};

/**
 * Leert die Navigations-Historie.
 */
gc.gis.module.GCNavigationHistory.prototype.reset = function()
{
	this.history_index = 0;
	this.history = [];
	this.addViewport(this.map.getViewport());
	this.__updateButtons();
};

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype.addViewport = function(viewport)
{
	this.history.push(viewport);
};

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype.goPrev = function()
{
	this.btn_next.attr('disabled', true );
	this.btn_prev.attr('disabled', true );
	this._active = true;

	this.history_index--;

	this.map.setViewport(this.history[this.history_index]);
	this.btn_prev.blur();

	this.__updateButtons();
};

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype.goNext = function()
{
	this.btn_next.attr('disabled', true);
	this.btn_prev.attr('disabled', true);
	this._active = true;

	this.history_index++;

	this.map.setViewport(this.history[this.history_index]);
	this.btn_next.blur();

	this.__updateButtons();
};

/**
 *
 */
gc.gis.module.GCNavigationHistory.prototype.__updateButtons = function()
{
	// Vorheriger-Button
	if(this.history_index === 0)
	{
		this.btn_prev.attr('disabled', true);
	}
	else if(this.history.length > 0)
	{
		this.btn_prev.removeAttr('disabled');
	}

	// Nächster-Button
	if(this.history_index === this.history.length - 1 || this.history.length === 0)
	{
		this.btn_next.attr('disabled', true);
	}
	else if(this.history_index < this.history.length - 1 && this.history.length > 0)
	{
		this.btn_next.removeAttr('disabled');
	}
};
